import React from "react";
import {
  InfoSec,
  InfoColumn,
  InfoRow,
  TextWrapper,
  TopLine,
  Heading,
  Subtitle,
  ImgWrapper,
  Img,
  ButtonDiv,
  InfoContainer,
  Links,
} from "./InfoSection.elements";
import { Button, Container } from "../../globalStyles";
import cv from "../../cv/CV.pdf";
import TypeWritter from "typewriter-effect";
import img from "../../images/trabajo.png";

export default function InfoSection({ id, light }) {
  const visibleButton = true;
  return (
    <>
      <InfoSec id={id} lightBg={true} className="seccion" light={light}>
        <Container>
          <InfoContainer>
            <InfoRow imgStart={""}>
              <InfoColumn>
                <TextWrapper>
                  <TopLine light={light}>BIENVENIDOS</TopLine>
                  <Heading light={light} id="heading">
                    <TypeWritter
                      onInit={(typewriter) => {
                        typewriter
                          .typeString("A MI PÁGINA WEB PERSONAL")
                          .start();
                      }}
                    />
                  </Heading>
                  <Subtitle id="texto" light={light}>
                    Soy Alonso Díaz Sobrino, graduado en ingeniería
                    informática por la
                    <Links
                      light={light}
                      href="https://www.uclm.es/"
                      target="_blank"
                    >
                      <span> </span> Universidad de Castilla-La Mancha (UCLM) <span></span>
                    </Links>
                     con mención en Tecnologías de la
                    Información.
                    Y actualmente, me encuentro trabajando para NTT Data una empresa japonesa multinacional
                    de consultoría y servicios de tecnología de la información.
                    
                  </Subtitle>

                  <ButtonDiv visibleButton={visibleButton}>
                    {visibleButton ? (
                      <a href={cv} download="CV.pdf">
                        <Button light={light} primary={true}>
                          DESCARGAR CV
                        </Button>
                      </a>
                    ) : (
                      ""
                    )}
                  </ButtonDiv>
                </TextWrapper>
              </InfoColumn>
              <InfoColumn>
                <ImgWrapper light={light} start={""}>
                  <Img src={img} alt={"Image"} />
                </ImgWrapper>
              </InfoColumn>
            </InfoRow>
          </InfoContainer>
        </Container>
      </InfoSec>
    </>
  );
}
